var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Enti al Target")]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('v-row',{staticClass:"mt-5"},[_c('v-col',{attrs:{"cols":"6"}},[_c('enti-al-target',{attrs:{"statistica":_vm.statisticaEnti}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }